import { Evidence } from "@p0security/shared/types/evidence";
import { Tenant } from "components/Login";
import { orderBy } from "firebase/firestore";
import { EVIDENCE_COLLECTION } from "firestore/constants";
import { useFirestoreCollection } from "providers/FirestoreProvider";
import { useContext, useEffect, useState } from "react";

export const useActivePreApproval = () => {
  const [loading, setLoading] = useState(true);
  const tenantId = useContext(Tenant);
  const { docs: preApproval } = useFirestoreCollection<Evidence>(
    `o/${tenantId}/${EVIDENCE_COLLECTION}`,
    {
      live: true,
      queryConstraints: [orderBy("startsAt", "desc")],
    }
  );

  useEffect(() => {
    if (preApproval !== undefined) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [preApproval]);

  return {
    loading,
    list:
      preApproval?.filter(
        (e) =>
          !e.data.revokedAt &&
          e.data.endsAt >= Date.now() &&
          e.data.source === "allow"
      ) ?? [],
  };
};
